import {
    CreateFutureOrderAPIResponseType,
    FXOrderFormRequiredType,
    FXOrderFormType,
    FXOrderTransactionAcknowledgementType, FXOrderTransactionAcknowledgementTypeForFuture
} from "../../../../../types/fx.type";
import {
    DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT,
    FX_ORDER_CONFIRM_STATUS_CODE, FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_CODE,
    FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_TYPE
} from "../../../../../constants/fx.constant";
import {getIntlObject} from "../../../../../utils/intl";
import moment from "moment/moment";
import {formatNumber} from "../../../../../utils/common.utils";
import {getConversionFee} from "../../../order";
import {renderRate} from "../../../../../components/order/CalculationCard";
import {store} from "../../../../../store/store";

function formatDateString(input: string): string {
    // Extracting year, month, day, etc. from the string
    const year = parseInt(input.substring(0, 4), 10);
    const month = parseInt(input.substring(4, 6), 10) - 1; // Month is 0-indexed in JavaScript
    const day = parseInt(input.substring(6, 8), 10);
    const hour = parseInt(input.substring(8, 10), 10);
    const minute = parseInt(input.substring(10, 12), 10);
    const second = parseInt(input.substring(12, 14), 10);

    // Create a new date object
    const date = new Date(year, month, day, hour, minute, second);

    // Format the date
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric', month: 'long', day: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: true
    };
    return date.toLocaleDateString('en-US', options);
}

function formatDateWithFixedTime(dateString: string): string {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-GB", {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    });

    return formattedDate + "\n11:59:59 PM";
}

function formatDecimal(inputNumber: string | number, numberOfDecimals: number): string {
    const number = typeof inputNumber === 'string' ? parseFloat(inputNumber) : inputNumber;

    if (isNaN(number)) {
        return 'Invalid number';
    }

    return number.toFixed(numberOfDecimals);
}

export const formatCreateFutureOrder = (
    response: CreateFutureOrderAPIResponseType,
    fxOrderForm: FXOrderFormType
): FXOrderTransactionAcknowledgementTypeForFuture | FXOrderTransactionAcknowledgementType => {
    const intl = getIntlObject();
    const unitQuote = store.getState().fx.unitQuote
    const dp = store.getState().fx.dp
    if (response.responseCode === FX_ORDER_CONFIRM_STATUS_CODE.SUCCESS) {
        return {
            transactionStatus: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_TYPE.SUCCESS,
            statusDescription: intl.formatMessage({
                id: "app.page.futureReceipt.statusDescription.success.text",
            }),
            statusCode: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_CODE.SUCCESS,
            orderId: response.data.orderId,
            transactionDate: formatDateString(response.data.inputDate),
            fromAccount: fxOrderForm.bankAccount.source!.id,
            fromAccountName: fxOrderForm.bankAccount.source!.label,
            toAccount: fxOrderForm.bankAccount.target!.id,
            toAccountName: fxOrderForm.bankAccount.target!.label,
            convertedFrom: `${fxOrderForm.source.currency} ${formatDecimal(fxOrderForm.source.amount.value, fxOrderForm.fx?.decimalPoint as number)}`,
            amountReceived: `${fxOrderForm.target.currency} ${formatDecimal(fxOrderForm.target.amount.value, fxOrderForm.fx?.decimalPoint as number)}`,
            targetRate: renderRate(fxOrderForm.fx!.currencies[0], fxOrderForm.fx!.currencies[1], fxOrderForm.futureTargetRate!,dp, unitQuote),
            // executionRate: "we don't know what is executionRate",
            transactionType: intl.formatMessage({
                id: "app.page.transactionReceipt.transactionType.future.text",
            }),
            conversionFee: `${fxOrderForm.fee.currency} ${formatNumber(
                getConversionFee(),
                DEFAULT_FX_ORDER_CURRENCY_AMOUNT_DECIMAL_POINT
            )}`,
            receiptTitle: intl.formatMessage({
                id: "app.page.transactionReceipt.receipt.title",
            }),
            expiryDate: formatDateWithFixedTime(fxOrderForm.expiryDate!)
        }
    } else {
        return {
            transactionStatus: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_TYPE.FAIL,
            statusDescription: intl.formatMessage({
                id: "app.page.transactionReceipt.statusDescription.fail.text",
            }),
            statusCode: FX_ORDER_TRANSACTION_ACKNOWLEDGEMENT_STATUS_CODE.FAIL,
            failureMessage: JSON.stringify({
                referenceId: "",
                //@ts-ignore
                orderId: response.data.orderId,
                "date&time": moment
                    //@ts-ignore
                    .utc(response.data.tradeDate, "YYYYMMDDHHmmss")
                    .local()
                    .format("YYYY-MM-DD HH:mm:ss"),
            }),
        };
    }
}
